<template>
	<div>
		<CTreeNode v-for="node in tree" :key="node.id" :node="node" v-on="$listeners" :layerPadding="layerPadding">
			<template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
				<slot :name="slot" v-bind="scope" />
			</template>
		</CTreeNode>
	</div>
</template>

<script>
import CTreeNode from "./CTreeNode"

export default {
	components: {
		CTreeNode
	},

	props: {
		tree: {
			type: Array,
			required: true,
			default: () => []
		},

		layerPadding: {
			type: Number,
			default: 8
		}
	}
}
</script>
